import React from "react";

import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Divider, Paper } from "@mui/material";
import MenuMessages from "./MenuListMessages";
import MessagePanelOpenCard from "./MessagePanelOpenCard";
import NotificationPanelOpenCard from "./NotificationPanelOpenCard";
import NotificationList from "./NotificationList";
import MobilePanelOpenCard from "./MobilePanelOpenCard";

const MobileDropdown2 = ({ anchorEl,setMobileMenu, setMobileDrawerState,setOpenMessagePanel , setNotificationMenu , setOpenNotificationPanel,t }) => {
  const open = Boolean(anchorEl);

  const id = open ? "simple-popover" : undefined;
 
  const handleClose = () => {
    setMobileMenu(null);
  };

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Paper sx={{ p: 2 }}>
        <MobilePanelOpenCard  setOpenMessagePanel={setOpenMessagePanel} setMobileDrawerState={setMobileDrawerState} setMobileMenu={setMobileMenu} setNotificationMenu={setNotificationMenu} setOpenNotificationPanel={setOpenNotificationPanel} t={t} />
      </Paper>
    </Popover>
  );
};

export default MobileDropdown2;
